<template>
  <div class="sheet" :class="{expanded}">
    <header class="sheet-toggle card bg-dark text-light rounded-0">
      <div class="card-header h5 bg-blur-darker hover-darken text-light d-flex align-items-center pointer-event" @click="toggleExpanded">
        <HamburgerIcon class="me-2" :expanded="expanded"/>
        <span>{{ $t('js.sidebar.headers.voting_rounds') }}</span>
      </div>
    </header>
    <div class="sheet-flyout master-detail-grid border border-dark bg-blur-dark text-white">
      <VotingRounds :selectedRound="activeVotingRoundId" @toggleRound="toggleActive"></VotingRounds>
      <VotingRoundReport :voting-round="activeVotingRound" v-if="activeVotingRound"/>
    </div>
  </div>
</template>

<script>
import HamburgerIcon from "./HamburgerIcon.vue";
import { mapState } from "vuex";
import VotingRoundReport from "./VotingRoundReport.vue";
import BaseSectionList from "../../shared/BaseSectionList.vue";
import VotingRounds from "../../backend/VotingRounds.vue";

export default {
  name: "VotingRoundsSheet",
  components: {VotingRounds, BaseSectionList, VotingRoundReport, HamburgerIcon},
  data: () => ({
    expanded: false,
    activeVotingRoundId: 1,
  }),
  computed: {
    ...mapState(["votingRounds"]),
    activeVotingRound() {
      return this.votingRounds.find(vr => vr.id === this.activeVotingRoundId)
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    toggleActive(votingRoundId) {
      this.activeVotingRoundId = this.activeVotingRoundId === votingRoundId ? null : votingRoundId;
    },
  }
}
</script>

<style scoped>
.sheet {
  z-index: 10;
  position: relative;
  isolation: isolate;
}

.sheet-flyout {
  z-index: -1;
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  transition: all 350ms ease;
  box-shadow: 0 0 0 black;
  overflow: clip;
}

.sheet.expanded > .sheet-flyout {
  top: calc(-60vh - 1px);
  box-shadow: 0 -1rem 1rem -1rem rgba(0, 0, 0, 0.84);
}

.sheet-toggle {
  transition: transform 350ms ease;
}

.sheet.expanded > .sheet-toggle {
  transform: translateY(calc(-60vh - 100%));
  box-shadow: 0 -1rem 1rem -1rem rgba(0, 0, 0, 0.84);
}

.master-detail-grid {
  display: grid;
  grid-template-areas: "master detail";
  grid-template-columns: 20rem 1fr;
}
</style>
